import { render, staticRenderFns } from "./bpb-zoombox-button.vue?vue&type=template&id=7dd868b2&"
import script from "./bpb-zoombox-button.vue?vue&type=script&lang=js&"
export * from "./bpb-zoombox-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports